<template>
  <div>
    <modal
      title="Update Expense"
      name="updateExpenses"
      class="custom-modal"
      height="auto"
      width="50%"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <form @submit.prevent class="create-service mb-base">
            <div class="flex space-between">
              <Select
                class="mb-base type-select"
                label="Expense Type"
                :value="expenses.name"
                :input="handleExpenseType"
                :options="types"
                :clearable="false"
              />
              <Select
                class="mb-base type-select"
                label="Type"
                :input="handleCreditDebit"
                :options="['Credit', 'Debit']"
                :placeholder="currentData.type"
                :clearable="false"
              />
            </div>
            <div
              class="new-expense flex align-center mb-base cursor"
              @click="newExpense"
            >
              <img src="@/assets/plus-icon-small.png" alt="icon" />
              <span>Add new Expense type </span>
            </div>
            <Input
              v-if="newExpenseType"
              class="mb-base expense-input"
              type="text"
              v-model="expenses.name"
            />
            <div class="flex">
              <Input
                class="mb-base expense-input"
                label="Amount"
                type="number"
                v-model="currentData.amount"
              />
              <Input
                label="Selected Branch"
                v-model="currentData.selectedBranch"
                class="mb-base ml-2 type-select"
                :disabled="true"
              />
            </div>
            <TextArea
              styles="text-area mb-base"
              label="Narration"
              rows="3"
              name="narration"
              v-model="currentData.narration"
            />
            <Button
              className="button--primary"
              title="Update"
              :onClick="handleUpdate"
            ></Button>
          </form>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Select from "@/components/Select";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import TextArea from "@/components/TextArea";
import { mapGetters, mapActions } from "vuex";
import { formatExpenseType } from "@/utils/helpers";
// import { formatedDate } from "../../../utils/helpers";
export default {
  components: {
    TextArea,
    Button,
    Select,
    Modal,
    Input
  },
  props: ["actions", "types", "currentData", "selectedBranch"],
  data() {
    return {
      expenses: {},
      newExpenseType: false,
      brachData: [],
      placeholder: ""
    };
  },
  methods: {
    ...mapActions("expenses", [
      "updateExpenses",
      "fetchBranch",
      "expensesDetails"
    ]),
    newExpense() {
      this.newExpenseType = !this.handleSelectBranchnewExpenseType;
    },
    handleUpdate() {
      this.expenses.userId = this.user.id;
      this.expenses.type = formatExpenseType(this.currentData.type);

      this.updateExpenses(this.expenses).then(() => {
        this.$modal.hide("updateExpenses");
        this.$toasted.success("Expense updated successfully").goAway("3000");
      });
    },
    handleCreditDebit(val) {
      this.expenses.type = val;
    },
    handleExpenseType(val) {
      this.expenses.name = val.name;
    },
    handleSelectBranch(val) {
      this.expenses.branchId = val.key;
    }
  },
  watch: {
    actions(val) {
      let expenses = val;
      delete expenses.createdBy;
      delete expenses.serial;
      this.expenses = expenses;
    }
  },
  computed: {
    ...mapGetters({
      getExpenses: "expenses/getExpenses",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch"
    })
  },
  async mounted() {
    await this.fetchBranch();
    this.fetchUserBranch.map(elem => {
      this.value = elem.name;
      this.brachData.push({ name: elem.name, key: elem.id });
    });
  }
};
</script>

<style></style>
